import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { AppLink } from "@/components/common/app-link";
import { ProviderMark } from "@/components/common/badges";
import { q } from "@/data/queries";
import { projectPath } from "@/lib/nav";

export const Route = createFileRoute("/p/$project/inbox/")({
  component: InboxIndexPage,
});

function InboxIndexPage() {
  const { project } = Route.useParams();
  const { data: chats } = useSuspenseQuery(q.chatsWithMessages());

  return (
    <div className="flex min-h-0 flex-1 items-center justify-center p-8">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <h1 className="text-[15px] font-semibold">One inbox, every provider</h1>
        <p className="text-[13px] leading-[1.55] text-muted-foreground">
          The account-based channels behind the same shape as mail. Pick one on the
          left, or open a thread with full history:
        </p>
        <ul className="flex w-full flex-col gap-1.5">
          {chats.map((chat) => (
            <li key={chat.id}>
              <AppLink
                to={projectPath(project, `/inbox/${chat.id}`)}
                className="flex items-center gap-2.5 rounded-md border px-3 py-2 text-left transition-colors hover:bg-accent/50 focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:outline-none"
              >
                <ProviderMark provider={chat.provider} size="sm" />
                <span className="min-w-0 flex-1 truncate text-[13px]">{chat.name}</span>
                <span className="shrink-0 text-[11px] text-ink-faint">{chat.kind}</span>
              </AppLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
